import {message} from "antd";
import {useUpdateUserProfile} from "../../../../features/profile/hooks/useProfile";
import {GetUserProfileApiResponse} from "../../../../react-query-hooks/profile/types";
import {ProfileFormValues} from "../form/schema-validation";
import {updateUserProfileDto} from "../upadate-profile-service";
import {useGetProfileContext} from "../../../../context/profile/profile-context";
import {scrollToTop} from "../../../../hooks/use-scroll-to-top";

declare const window: Window &
  typeof globalThis & {
    Intercom: any;
    heap: any;
  };

interface HookResult {
  updateUserProfile(values: ProfileFormValues): void;
  wasUserProfileUpdated: boolean;
  isUpdatingUserProfile: boolean;
  responseData?: GetUserProfileApiResponse;
}

export function useUpdateUserProfileHook(): HookResult {
  const updateUserProfileMutation = useUpdateUserProfile();
  const {
    state: {
      profileData: {userId, email},
    },
  } = useGetProfileContext();

  const updateUserProfile = (values: ProfileFormValues) => {
    updateUserProfileMutation.mutate(updateUserProfileDto(values), {
      onSuccess(data) {
        scrollToTop();
        message.success("Your profile has been updated successfully!");
        window.heap.identify(`${userId}: ${values.firstName} ${values.lastName}`);
        window.Intercom("update", {
          name: `${values.firstName} ${values.lastName}`,
          email: `${email.toLowerCase()}`,
          user_id: `${userId}`,
        });
      },
    });
  };
  return {
    updateUserProfile,
    wasUserProfileUpdated: updateUserProfileMutation.isSuccess,
    isUpdatingUserProfile: updateUserProfileMutation.isLoading,
    responseData: updateUserProfileMutation.isSuccess
      ? updateUserProfileMutation.data.data
      : undefined,
  };
}
